let API_ENDPOINT = `${window.origin}/api`;

const AUTH_STORAGE_KEY = 'dst';

if (process.env.NODE_ENV === 'production') {
  API_ENDPOINT = `${window.origin}`;
}

export { API_ENDPOINT, AUTH_STORAGE_KEY };
